class ModernVideo extends HTMLElement {
  connectedCallback() {
    this.overlay  = this.querySelector('.mv-popup-overlay');
    this.iframe   = this.querySelector('.mv-popup iframe');
    this.thumb    = this.querySelector('.mv-video-thumb');
    this.closeBtn = this.querySelector('.mv-popup-close');
    this.videoUrl = this.dataset.videoUrl || '';

    this.thumb?.addEventListener('click', () => this.openPopup());
    this.closeBtn?.addEventListener('click', () => this.closePopup());
    this.overlay?.addEventListener('click', (e) => {
      if (e.target === this.overlay) this.closePopup();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closePopup();
    });
  }

  openPopup() {
    const embedUrl = this.buildEmbedUrl(this.videoUrl);
    if (!embedUrl) return;
    this.iframe.src = embedUrl;
    this.overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  closePopup() {
    this.overlay.classList.remove('is-open');
    this.iframe.src = '';
    document.body.style.overflow = '';
  }

  buildEmbedUrl(url) {
    if (!url) return null;
    let videoId = null;

    const short = url.match(/youtu\.be\/([^?&]+)/);
    const long  = url.match(/[?&]v=([^?&]+)/);
    const embed = url.match(/youtube\.com\/embed\/([^?&]+)/);

    if (short)  videoId = short[1];
    else if (long)  videoId = long[1];
    else if (embed) videoId = embed[1];

    if (!videoId) return null;
    return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
  }
}

customElements.define('modern-video', ModernVideo);
